import { request } from '@/shared/api/request'

export const removeProject = ({params}) => {
	return request({
		method: 'POST',
		url: 'staff/delProject',
		params
	})
}
